import { TerminalEventMonitoring } from '@lightspeed-payments/payments-terminal-sdk'

export const getMonitoringInstance = (
  outletId: string,
  isSandbox: boolean,
  integrationType: 'LOCAL' | 'CLOUD'
) =>
  TerminalEventMonitoring.init({
    clientToken: 'pub2fbfbdb5405eac9ebb836b10d5e40e63',
    env: isSandbox ? 'STAGE' : 'PROD',
    product: 'XSERIES',
    pli: getPli(outletId),
    processor: 'STRIPE',
    integrationType,
    platformType: 'WEB',
    verbose: isSandbox,
  })

const getPli = (outletId: string): string => {
  return 'lsx:' + outletId
}
